<template>

  <div class="food-card bg-white border-" :id="`un-auth-side-product-${food.id}`">
    <div class="row">
      <div class="col-lg-6">
        <img class="w-100 shop-food-img" :src="subProductImage(food,subProduct)" :alt="food.name"/>
      </div>
      <div class="d-flex flex-column align-items-start justify-content-center text-right col-lg-6">
        <h5 class="text-dark my-1">{{ productName(food, subProduct) }} </h5>
        <!--  productName(food,null)      -->
        <div dir="rtl">
          <span v-if="calculatePriceAndOffer(food, subProduct)['offer'] > 0" class="d-block">
            <del v-html="$t('price.price',{currency:formatNumber(calculatePriceAndOffer(food, subProduct)['price'])})"></del>
          </span>
          <span class="d-block"
                v-html="$t('price.price',{currency:formatNumber(calculatePriceAndOffer(food, subProduct)['price']-calculatePriceAndOffer(food, subProduct)['offer'])})"></span>
        </div>
        <slot name="comment-btn"></slot>
      </div>
      <div class="col-lg-12 text-center my-3">
        <m-product-card-quantity-manager1 :sub-product="subProduct" :product="food"/>
      </div>
    </div>
  </div>

</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {mapGetters} from "vuex";
import mProductPrice100 from "../../Product/ProductPrice100";
import mProductCardQuantityManager1 from "../../Product/QuantityManager/Card/ProductCardQuantityManager1";
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import {productName} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";

export default {
  name: "C17",
  components: {mProductCardQuantityManager1, mProductPrice100},
  props: {
    food: {},
    basket: {},
    subProduct: {
      default: null
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      IsAuthenticated: "User/isAuthenticated"
    }),
  },
  methods: {
    productName,
    ...shoppingCartFunctions,
    formatNumber,
  },
  async mounted() {
    console.log(this.food, this.subProduct)
  }
}
</script>

<style scoped>
.food-card {
  border-radius: 25px;
  padding: 5px;
  height: max-content;
}

.shop-food-img {
  border-radius: 25px;
  height: 150px;
  object-fit: cover;
}

</style>